import "core-js/modules/es.array.push.js";
import { mapGetters, mapMutations } from 'vuex';
import { ElMessage } from 'element-plus';
import { setLocale } from '@/locales';
import { logoutSession } from '@/utils/authSession';
import { PhUser, PhSun, PhMoon, PhMonitor, PhSignOut, PhGear, PhGlobe } from '@phosphor-icons/vue';
export default {
  name: 'AccountMenu',
  components: {
    PhUser,
    PhSun,
    PhMoon,
    PhMonitor,
    PhSignOut,
    PhGear,
    PhGlobe
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      loggingOut: false,
      logoutError: ''
    };
  },
  computed: {
    ...mapGetters(['useDarkMode', 'cusDarkMode']),
    themeMode() {
      if (!this.cusDarkMode) return 'auto';
      return this.useDarkMode ? 'dark' : 'light';
    },
    themeIcon() {
      if (this.themeMode === 'dark') return PhMoon;
      if (this.themeMode === 'light') return PhSun;
      return PhMonitor;
    },
    themeLabel() {
      const m = this.themeMode;
      const map = {
        auto: 'theme.autoMode',
        light: 'theme.lightMode',
        dark: 'theme.darkMode'
      };
      return this.$t(map[m]);
    },
    languageLabel() {
      const map = {
        ko: '한국어',
        en: 'English'
      };
      return map[this.$i18n.locale] || this.$i18n.locale;
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKey);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKey);
  },
  methods: {
    ...mapMutations(['setUseDarkMode', 'setCusDarkMode', 'setAdminLoggedIn', 'setUserLoggedIn']),
    toggle() {
      if (this.loggingOut) return;
      if (!this.open) this.logoutError = '';
      this.open = !this.open;
    },
    close() {
      if (!this.loggingOut) this.open = false;
    },
    onKey(e) {
      if (e.key === 'Escape') this.close();
    },
    handleTheme() {
      const order = ['auto', 'light', 'dark'];
      const next = order[(order.indexOf(this.themeMode) + 1) % order.length];
      if (next === 'auto') {
        this.setCusDarkMode(false);
      } else {
        this.setCusDarkMode(true);
        this.setUseDarkMode(next === 'dark');
      }
    },
    handleLanguage() {
      const order = ['ko', 'en'];
      const next = order[(order.indexOf(this.$i18n.locale) + 1) % order.length];
      setLocale(next);
    },
    async handleLogout() {
      if (this.loggingOut) return;
      const next = this.isAdmin ? '/adminLogin' : '/login';
      this.loggingOut = true;
      this.logoutError = '';
      try {
        await logoutSession();
        this.setAdminLoggedIn(false);
        this.setUserLoggedIn(false);
        this.open = false;
        ElMessage.success(this.$t('upload.logoutSuccess'));
        this.$router.push(next).catch(error => {
          console.error('Logout redirect failed:', error);
        });
      } catch (error) {
        console.error('Logout failed:', error);
        this.logoutError = this.$t('appShell.logoutFailed');
        ElMessage.error(this.logoutError);
      } finally {
        this.loggingOut = false;
      }
    }
  }
};